var _path, _g, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeepLiquidity = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3682_16814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3682_16814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 6,
    width: 10,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.284 49.714V10.286a4.286 4.286 0 0 0-8.571 0v39.428a4.286 4.286 0 0 0 8.571 0Z",
    fill: "url(#paint0_linear_3682_16814)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3682_16814)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.284 49.714V10.286a4.286 4.286 0 0 0-8.571 0v39.428a4.286 4.286 0 0 0 8.571 0Z",
    fill: "url(#paint1_linear_3682_16814)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3682_16814)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.252,
    cy: 40.259,
    rx: 8.254,
    ry: 7.687,
    fill: "#95F0FB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.034 10.286v39.428a4.036 4.036 0 0 1-8.071 0V10.286a4.036 4.036 0 1 1 8.071 0Z",
    stroke: "url(#paint2_linear_3682_16814)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.57 49.714V23.143a2.571 2.571 0 0 0-5.142 0v26.571a2.571 2.571 0 0 0 5.143 0Z",
    fill: "url(#paint3_linear_3682_16814)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3682_16814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 25,
    width: 10,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.284 49.715V30a4.286 4.286 0 0 0-8.571 0v19.715a4.286 4.286 0 1 0 8.571 0Z",
    fill: "url(#paint4_linear_3682_16814)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3682_16814)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.284 49.715V30a4.286 4.286 0 0 0-8.571 0v19.715a4.286 4.286 0 1 0 8.571 0Z",
    fill: "url(#paint5_linear_3682_16814)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3682_16814)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.151,
    cy: 43.799,
    rx: 9.629,
    ry: 8.969,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.57 49.715v-9.429a2.571 2.571 0 0 0-5.142 0v9.429a2.571 2.571 0 0 0 5.143 0Z",
    fill: "#C9975A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.034 30v19.715a4.036 4.036 0 1 1-8.071 0V30a4.036 4.036 0 0 1 8.071 0Z",
    stroke: "url(#paint6_linear_3682_16814)",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3682_16814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 10,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.284 49.714V24.857a4.286 4.286 0 0 0-8.571 0v24.857a4.286 4.286 0 0 0 8.571 0Z",
    fill: "url(#paint7_linear_3682_16814)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3682_16814)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.284 49.714V24.857a4.286 4.286 0 0 0-8.571 0v24.857a4.286 4.286 0 0 0 8.571 0Z",
    fill: "url(#paint8_linear_3682_16814)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.57 49.713V36a2.571 2.571 0 1 0-5.142 0v13.714a2.572 2.572 0 0 0 5.143 0Z",
    fill: "url(#paint9_linear_3682_16814)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.034 24.857v24.857a4.036 4.036 0 1 1-8.071 0V24.857a4.036 4.036 0 1 1 8.071 0Z",
    stroke: "url(#paint10_linear_3682_16814)",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3682_16814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 36,
    width: 10,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.284 49.714v-9.428a4.286 4.286 0 0 0-8.571 0v9.428a4.286 4.286 0 0 0 8.571 0Z",
    fill: "url(#paint11_linear_3682_16814)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3682_16814)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.284 49.714v-9.428a4.286 4.286 0 0 0-8.571 0v9.428a4.286 4.286 0 0 0 8.571 0Z",
    fill: "url(#paint12_linear_3682_16814)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3682_16814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.428 49.714a2.571 2.571 0 1 0 5.143 0 2.571 2.571 0 0 0-5.143 0Z",
    fill: "#C9975A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.034 40.286v9.428a4.036 4.036 0 0 1-8.071 0v-9.428a4.036 4.036 0 0 1 8.071 0Z",
    stroke: "url(#paint13_linear_3682_16814)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_3682_16814)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.109,
    cy: 63.402,
    rx: 8.254,
    ry: 7.687,
    fill: "#95F0FB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3682_16814",
    x1: 46.999,
    y1: 6,
    x2: 46.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3682_16814",
    x1: 46.999,
    y1: 6,
    x2: 46.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3682_16814",
    x1: 46.999,
    y1: 6,
    x2: 46.999,
    y2: 28.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3682_16814",
    x1: 46.999,
    y1: 20.571,
    x2: 46.999,
    y2: 54.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3682_16814",
    x1: 34.999,
    y1: 25.715,
    x2: 34.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3682_16814",
    x1: 34.999,
    y1: 25.715,
    x2: 34.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3682_16814",
    x1: 34.999,
    y1: 25.715,
    x2: 34.999,
    y2: 38.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3682_16814",
    x1: 22.999,
    y1: 20.571,
    x2: 22.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3682_16814",
    x1: 22.999,
    y1: 20.571,
    x2: 22.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3682_16814",
    x1: 22.999,
    y1: 33.428,
    x2: 22.999,
    y2: 53.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3682_16814",
    x1: 22.999,
    y1: 20.571,
    x2: 22.999,
    y2: 35.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3682_16814",
    x1: 10.999,
    y1: 36,
    x2: 10.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3682_16814",
    x1: 10.999,
    y1: 36,
    x2: 10.999,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3682_16814",
    x1: 10.999,
    y1: 36,
    x2: 10.999,
    y2: 44.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3682_16814",
    x: 36.713,
    y: 0,
    width: 20.572,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3682_16814",
    x: 26.998,
    y: 6.571,
    width: 68.507,
    height: 67.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3682_16814"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3682_16814",
    x: 34.428,
    y: 12.571,
    width: 29.143,
    height: 55.714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_3682_16814",
    x: 24.713,
    y: 19.715,
    width: 20.572,
    height: 40.286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3682_16814",
    x: 1.521,
    y: 8.83,
    width: 71.258,
    height: 69.937,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3682_16814"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3682_16814",
    x: 22.428,
    y: 29.715,
    width: 29.143,
    height: 38.571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_3682_16814",
    x: 12.713,
    y: 14.571,
    width: 20.572,
    height: 45.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3682_16814",
    x: 10.428,
    y: 25.428,
    width: 29.143,
    height: 42.857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_3682_16814",
    x: 0.713,
    y: 30,
    width: 20.572,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3682_16814",
    x: -1.572,
    y: 39.143,
    width: 29.143,
    height: 29.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16814",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3682_16814",
    x: -32.145,
    y: 29.715,
    width: 68.507,
    height: 67.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3682_16814"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3682_16814"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgDeepLiquidity;